module.exports = __webpack_public_path__ + "static/media/entry.5de9a69f.png";